export const readCookie = (key, cookie = document.cookie) => {
  const pattern = `(?:^|;)\\s*${key}=([^;]*)`;
  const matches = cookie.match(pattern);
  return matches
    ? decodeURIComponent(matches[1]).replace(/^"|"$/g, '')
    : undefined;
};
